var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: _vm.inputContainerId } },
    [
      _c("rb-textfield", {
        ref: "location",
        attrs: {
          id: _vm.id,
          type: "text",
          name: "location",
          label: _vm.label,
          validation: _vm.$v.location,
          error: "",
          disabled: _vm.disabled,
          iconclass: "common__icon--search",
          autcomplete: "off",
        },
        on: { onIconClick: _vm.onSearchIconClick },
        nativeOn: {
          blur: function ($event) {
            return _vm.getValue($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }